import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import type { TopPage } from '@/lib/analytics/googleAnalyticsData';

interface TopPagesTableProps {
  data: TopPage[];
  isLoading?: boolean;
}

/**
 * Table des pages les plus vues
 */
export function TopPagesTable({ data, isLoading }: TopPagesTableProps) {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Pages les plus vues</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px] flex items-center justify-center">
            <p className="text-sm text-gray-500">Chargement...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Pages les plus vues</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px] flex items-center justify-center">
            <p className="text-sm text-gray-500">Aucune donnée disponible</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Pages les plus vues</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Page</TableHead>
              <TableHead className="text-right">Vues</TableHead>
              <TableHead className="text-right">Visiteurs uniques</TableHead>
              <TableHead className="w-[50px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((page, index) => (
              <TableRow key={index}>
                <TableCell>
                  <div className="space-y-1">
                    <p className="font-medium text-sm">{page.title || 'Sans titre'}</p>
                    <p className="text-xs text-gray-500">{page.path}</p>
                  </div>
                </TableCell>
                <TableCell className="text-right font-medium">
                  {page.views.toLocaleString('fr-FR')}
                </TableCell>
                <TableCell className="text-right text-gray-600">
                  {page.uniqueViews.toLocaleString('fr-FR')}
                </TableCell>
                <TableCell>
                  <Button
                    variant="ghost"
                    size="sm"
                    asChild
                    className="h-8 w-8 p-0"
                  >
                    <a
                      href={`${import.meta.env.VITE_SITE_URL}${page.path}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Ouvrir la page"
                    >
                      <ExternalLink className="w-4 h-4" />
                    </a>
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
